<footer>
  <section class="ft-main">
    @if(hasLinks()){
    <ul class="m-0 d-flex small-gap justify-content-center ">
      @for(link of links(); track link.href){
      <li>
        <a *ngIf="link.href" [href]="link.href" target="_blank" [title]="link.title" class="ctn-social-icon"
          [ngClass]="'ctn-social-icon-'+link.icon" [id]="link.title">
          <cnet-icon size="1" [name]="link.icon" [label]="link.title"></cnet-icon>
        </a>
      </li>
      }
    </ul>
    }
    <a href="https://www.contratanet.com.br" target="_blank" rel="nofollow" class="d-flex">
      <img src="/assets/images/logos/symplicity/logo-symp-cnet-dark.svg" alt="Contratanet" width="254">
    </a>
  </section>
</footer>
